import { Navigate } from 'react-router-dom';
import { useLotteryToken } from './lottery/LotteryTokenProvider';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
    const { isAuthenticated, isAdmin } = useLotteryToken();

    if (!isAuthenticated) {
        return <Navigate to="/happypaylottery/login" replace />;
    }

    if (requireAdmin && !isAdmin) {
        return <Navigate to="/happypaylottery/unauthorized" replace />;
    }

    return children;
};

export default ProtectedRoute;